import { IMediaFormats } from '@services/inventory/inventory.services.type';
import { IPreviewWornItem } from 'src/features/character/features/characterInventory/components/Avatar/Avatar.type';
import { EIcon } from 'src/styles/theme/components/NGIcon/NGIcon.enum';
import { EAvatarItemType, EItemRarity } from 'src/styles/theme/utils/enums';

const BASE_AVATAR_ITEMS: IPreviewWornItem[] = [
	{
		id: -1,
		type: EAvatarItemType.onHead,
		icon: EIcon.helmet,
		srcPreviewCropped: {} as IMediaFormats,
		order: 1,
		rarity: EItemRarity.common
	},
	{
		id: -1,
		type: EAvatarItemType.onChest,
		icon: EIcon.armor,
		srcPreviewCropped: {} as IMediaFormats,
		order: 2,
		rarity: EItemRarity.common
	},
	{
		id: -1,
		type: EAvatarItemType.inRHand,
		icon: EIcon.weapon,
		srcPreviewCropped: {} as IMediaFormats,
		order: 3,
		rarity: EItemRarity.common
	},
	{
		id: -1,
		type: EAvatarItemType.inLHand,
		icon: EIcon.weaponShield,
		srcPreviewCropped: {} as IMediaFormats,
		order: 4,
		rarity: EItemRarity.common
	},
	{
		id: -1,
		type: EAvatarItemType.onHands,
		icon: EIcon.gloves,
		srcPreviewCropped: {} as IMediaFormats,
		order: 5,
		rarity: EItemRarity.common
	},
	{
		id: -1,
		type: EAvatarItemType.onLegs,
		icon: EIcon.boots,
		srcPreviewCropped: {} as IMediaFormats,
		order: 6,
		rarity: EItemRarity.common
	}
];

export { BASE_AVATAR_ITEMS };
